import React from "react";
import { useI18n } from "@/lib/i18n";
import { inputClass, labelClass } from "@/components/Brand";

const STATUSES = ["active", "trialing", "lifetime", "expired"];

/** Status, plan and the day-injection controls for a subscription override. */
export const OverrideFields = ({ status, setStatus, planId, setPlanId, days, setDays, fromNow, setFromNow, plans }) => {
  const { t } = useI18n();

  return (
    <div className="mt-6 space-y-5">
      <div>
        <label className={labelClass}>{t("subscription_status")}</label>
        <select data-testid="override-status-select" value={status} onChange={(e) => setStatus(e.target.value)}
          className="select-dark text-base sm:text-[10px] w-full mt-1 min-h-[44px] sm:min-h-0">
          {STATUSES.map((s) => (
            <option key={s} value={s}>
              {s === "lifetime" ? t("make_lifetime") : s === "expired" ? t("lock_now") : t(`sub_status_${s}`)}
            </option>
          ))}
        </select>
      </div>

      {status !== "expired" && (
        <div>
          <label className={labelClass}>{t("plans")}</label>
          <select data-testid="override-plan-select" value={planId} onChange={(e) => setPlanId(e.target.value)}
            className="select-dark text-base sm:text-[10px] w-full mt-1 min-h-[44px] sm:min-h-0">
            <option value="">{t("no_plan_change")}</option>
            {plans.map((p) => <option key={p.plan_id} value={p.plan_id}>{p.name}</option>)}
          </select>
        </div>
      )}

      {status === "active" || status === "trialing" ? (
        <>
          <div>
            <label className={labelClass}>{t("days_to_add")}</label>
            <input data-testid="override-days-input" type="number" className={inputClass} value={days}
              onChange={(e) => setDays(e.target.value)} />
          </div>
          <div className="flex flex-wrap gap-2">
            {[30, 90, 365].map((d) => (
              <button key={d} data-testid={`override-quick-${d}`} onClick={() => setDays(d)}
                className={`font-mono-accent text-[10px] tracking-[0.16em] border px-3 py-2 transition-colors ${
                  Number(days) === d ? "border-[#D4AF37] text-[#D4AF37]" : "border-[#2A2A2A] text-[#A8A8A8] hover:border-[#D4AF37]"
                }`}>
                +{d}
              </button>
            ))}
          </div>
          <label className="flex items-center gap-3 text-xs text-[#A8A8A8] cursor-pointer">
            <input data-testid="override-from-now" type="checkbox" checked={fromNow}
              onChange={(e) => setFromNow(e.target.checked)}
              className="accent-[#D4AF37] w-4 h-4" />
            {t("count_from_today")}
          </label>
        </>
      ) : null}
    </div>
  );
};
